// src/api/dashboard.js

import client from './client';
import { getUserId, getAuthCode } from './authStorage';

export async function getDashboardStats() {
  const payload = {
    user_id:   getUserId(),
    auth_code: getAuthCode()
  };
  const { data } = await client.post('/get_dashboard_stats.php', payload);
  if (data.status !== 200) {
    throw new Error(data.message);
  }
  return data.data; // { total_users, total_posts, ... }
}
